/* Auto Glow Up — FireTail buy box controller.
   Drives the bundle cards and per-tip colour swatches from the real Shopify
   variant data emitted by sections/agu-firetail-buy.liquid.

   Variant resolution:
     Single + C        -> variant (Single, C)
     Dual + C1 == C2   -> variant (Dual, C1)
     Dual + C1 != C2   -> variant (Dual, C1), both tips recorded as properties
   Per-tip choices are always sent as line item properties. */
(function () {
  var root = document.querySelector('[data-agu-ft]');
  var dataEl = document.querySelector('[data-agu-ft-data]');
  if (!root || !dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var QI = DATA.qtyIndex, CI = DATA.colorIndex;
  var colors = DATA.colors || [];

  var swatchCss = {};
  (DATA.swatchMap || '').split('\n').forEach(function (line) {
    var p = line.split('|');
    if (p.length === 2) swatchCss[p[0].trim().toLowerCase()] = p[1].trim();
  });
  function cssFor(name) {
    return swatchCss[String(name).toLowerCase()] || String(name).toLowerCase();
  }

  function findVariant(qty, color) {
    for (var i = 0; i < DATA.variants.length; i++) {
      var v = DATA.variants[i];
      if (v.options[QI] === qty && v.options[CI] === color) return v;
    }
    return null;
  }

  var cards = [].slice.call(root.querySelectorAll('[data-agu-bundle]'));
  var atc = root.querySelector('[data-agu-ft-atc]');
  var err = root.querySelector('[data-agu-ft-err]');

  var state = cards.map(function () {
    return { t1: colors[0], t2: colors[0] };
  });

  function showError(msg) {
    if (!err) return;
    if (msg) { err.textContent = msg; err.hidden = false; }
    else { err.textContent = ''; err.hidden = true; }
  }

  function paintCard(idx) {
    var card = cards[idx];
    var st = state[idx];
    var qty = card.getAttribute('data-qty');
    var v = findVariant(qty, st.t1);

    var priceEl = card.querySelector('[data-agu-price]');
    var cmpEl = card.querySelector('[data-agu-compare]');
    if (priceEl) priceEl.textContent = v ? v.priceStr : '';
    if (cmpEl) cmpEl.textContent = (v && v.compare > v.price) ? v.compareStr : '';

    card.querySelectorAll('[data-agu-swatches]').forEach(function (holder) {
      var tip = holder.getAttribute('data-agu-swatches');
      var chosen = tip === '2' ? st.t2 : st.t1;
      holder.querySelectorAll('.agu-ft__sw').forEach(function (btn) {
        var on = btn.getAttribute('data-color') === chosen;
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    });
  }

  function buildSwatches(idx) {
    var card = cards[idx];
    card.querySelectorAll('[data-agu-swatches]').forEach(function (holder) {
      var tip = holder.getAttribute('data-agu-swatches');
      holder.innerHTML = '';
      holder.setAttribute('role', 'radiogroup');
      colors.forEach(function (c) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'agu-ft__sw';
        btn.setAttribute('data-color', c);
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-label', c);
        btn.setAttribute('aria-checked', 'false');
        btn.style.setProperty('--sw', cssFor(c));
        btn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          if (tip === '2') state[idx].t2 = c; else state[idx].t1 = c;
          selectCard(idx);
          paintCard(idx);
          showError('');
        });
        holder.appendChild(btn);
      });
    });
  }

  function selectCard(idx) {
    cards.forEach(function (c, i) {
      c.classList.toggle('is-selected', i === idx);
      var r = c.querySelector('input[type=radio]');
      if (r) r.checked = (i === idx);
    });
  }

  function selectedIndex() {
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].classList.contains('is-selected')) return i;
    }
    return 0;
  }

  cards.forEach(function (card, idx) {
    buildSwatches(idx);
    paintCard(idx);
    card.addEventListener('click', function () {
      selectCard(idx);
      showError('');
    });
  });

  if (atc) {
    atc.addEventListener('click', function () {
      var idx = selectedIndex();
      var card = cards[idx];
      var st = state[idx];
      var qty = card.getAttribute('data-qty');
      var isDual = card.getAttribute('data-dual') === '1';
      var v = findVariant(qty, st.t1);

      if (!v) { showError('That combination is unavailable.'); return; }
      if (!v.available) { showError('That option is currently unavailable.'); return; }

      var props = {};
      props['Tip 1'] = st.t1;
      if (isDual) props['Tip 2'] = st.t2;

      atc.disabled = true;
      showError('');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          atc.disabled = false;
          if (!res.ok) { showError(res.j.description || 'Could not add to cart.'); return; }
          document.dispatchEvent(new CustomEvent('agu:cart:added', { detail: res.j }));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') { drawer.open(); }
          else { window.location.href = '/cart'; }
        })
        .catch(function () {
          atc.disabled = false;
          showError('Could not add to cart. Please try again.');
        });
    });
  }
})();
